export const SWITCH_UTILITY = "SWITCH_UTILITY";
export const RESET_UTILITY = "RESET_UTILITY";
